/* ==========================================================================
   CalendarEmbed Component
   Task F34: Cal.com booking embed for intake form onboarding section
   Uses iframe embed for team URLs (BookerEmbed requires numeric teamId)
   ========================================================================== */

import { Calendar, Mail } from 'lucide-react'

/**
 * Build a Cal.com embed URL from VITE_CALCOM_PRODUCT_URL.
 * Returns the full iframe src with embed params, or null if not configured.
 */
function getCalEmbedUrl(): string | null {
  const raw = import.meta.env.VITE_CALCOM_PRODUCT_URL as string | undefined
  if (!raw) return null

  // Ensure it's a full URL
  const url = raw.startsWith('http') ? raw : `https://cal.com/${raw}`

  return `${url}?embed=true&layout=month_view&hideBranding=true`
}

const calEmbedUrl = getCalEmbedUrl()

export function CalendarEmbed() {
  if (calEmbedUrl) {
    return (
      <div className="bg-white rounded-lg shadow-[0_1px_3px_rgba(0,0,0,0.08)] overflow-hidden">
        <iframe
          src={calEmbedUrl}
          title="Schedule onboarding call"
          className="w-full border-0"
          style={{ height: '680px' }}
          loading="lazy"
        />
      </div>
    )
  }

  // Fallback when Cal.com not configured
  return (
    <div className="bg-white rounded-lg shadow-[0_1px_3px_rgba(0,0,0,0.08)] p-8 text-center">
      <Calendar
        className="h-12 w-12 text-charcoal/30 mx-auto mb-4"
        aria-hidden="true"
      />
      <p className="text-charcoal/70 mb-2">
        Scheduling is being set up. In the meantime, reach out directly:
      </p>
      <a
        href="mailto:onboarding@tjmlabs.com"
        className="inline-flex items-center gap-2 text-deep-purple hover:underline font-medium"
      >
        <Mail className="h-4 w-4" aria-hidden="true" />
        onboarding@tjmlabs.com
      </a>
    </div>
  )
}

export default CalendarEmbed
